import { ISortByOption, ISortByValue } from './types';

/**
 * Only "Trending" appears in the design — the mockup never shows the menu open,
 * so these three siblings are inferred from the sort values the API exposes
 * (see `to-offering-search-sort`). Worth confirming the list and its labels with
 * design before this page ships.
 */
export const SORT_BY_OPTIONS: ISortByOption[] = [
  { value: 'trending', label: 'Trending' },
  { value: 'newest', label: 'Newest' },
  { value: 'closing-soon', label: 'Closing soon' },
  { value: 'most-funded', label: 'Most funded' },
];

/**
 * Kept in sync with `SortByMenu`'s own uncontrolled default so the page that
 * lifts the sort value can't drift from what the trigger displays on first
 * render.
 */
export const DEFAULT_SORT_BY_VALUE: ISortByValue = SORT_BY_OPTIONS[0].value;
